<template>
  <div class="row">
    <div class="col-md-6 offset-md-3 mt-3">
      <h4 class="text-center">
        เติมเหรียญ Rentini Coins
        <img :src="require('../assets/svg/rentini-coin.svg')" class="coin" />
      </h4>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th class="bg-dark-grey" scope="col">จำนวน Rentini Coins</th>
            <th class="bg-light-grey text-center" scope="col">ราคา</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">
              <img
                :src="require('../assets/svg/rentini-coin.svg')"
                class="coin"
              />
              50
            </th>
            <td class="text-center">
              <span class="price-box">50 บาท</span>
            </td>
          </tr>
          <tr>
            <th scope="row">
              <img
                :src="require('../assets/svg/rentini-coin.svg')"
                class="coin"
              />
              200
            </th>
            <td class="text-center">
              <span class="price-box">200 บาท</span>
            </td>
          </tr>
          <tr>
            <th scope="row">
              <img
                :src="require('../assets/svg/rentini-coin.svg')"
                class="coin"
              />
              500
              <span class="text-success">(+50)</span>
            </th>
            <td class="text-center">
              <span class="price-box">500 บาท</span>
            </td>
          </tr>
          <tr>
            <th scope="row">
              <img
                :src="require('../assets/svg/rentini-coin.svg')"
                class="coin"
              />
              1000
              <span class="text-success">(+150)</span>
            </th>
            <td class="text-center">
              <span class="price-box">1,000 บาท</span>
            </td>
          </tr>
          <tr>
            <th scope="row">
              <img
                :src="require('../assets/svg/rentini-coin.svg')"
                class="coin"
              />
              2500
              <span class="text-success">(+700)</span>
            </th>
            <td class="text-center">
              <span class="price-box">2,500 บาท</span>
            </td>
          </tr>
          <tr>
            <th scope="row">
              <img
                :src="require('../assets/svg/rentini-coin.svg')"
                class="coin"
              />
              5000
              <span class="text-success">(+2500)</span>
            </th>
            <td class="text-center">
              <span class="price-box">5,000 บาท</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.coin {
  width: 30px;
}
.bg-dark-grey {
  background-color: rgba(187, 187, 187, 1);
  color: rgba(72, 72, 72, 1);
}
.bg-light-grey {
  background-color: rgba(202, 202, 202, 1);
  color: rgba(72, 72, 72, 1);
}
.price-box {
  background-color: rgba(14, 157, 45, 1);
  color: white;
  padding: 5px 15px 5px 15px;
  border-radius: 25px;
}
</style>